import type {
  TValuesCurrentBlocks,
  TValuesCurrentPoints,
  TValuesCurrentProperties,
  TValuesCurrentRegions,
  TValuesTimeseriesBlocks,
  TValuesTimeseriesPoints,
  TValuesTimeseriesProperties,
  TValuesTimeseriesRegions,
} from 'App/Map/types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPointCategory } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const doesSelectedPropertyHaveValueTypes = ({
  valuesCurrent,
  valuesTimeseries,
}: {
  valuesCurrent?: TValuesCurrentProperties[]
  valuesTimeseries?: TValuesTimeseriesProperties[]
}): boolean => {
  const selectedFieldAssetState = selectedFieldAssetsStore.getState()
  const selectedProperty = selectedFieldAssetState.property
  const fieldAssets = fieldAssetStore.getState().properties
  const property = selectedProperty ? fieldAssets?.[selectedProperty] : null

  if (!property) return false

  if (valuesCurrent) {
    return valuesCurrent.some((vt) => property.valuesCurrent.includes(vt))
  }

  if (valuesTimeseries) {
    return valuesTimeseries.some((vt) => property.valuesTimeseries.includes(vt))
  }

  return false
}

export const doesSelectedPointHaveValueTypes = ({
  valuesCurrent,
  valuesTimeseries,
  pointCategory,
}: {
  valuesCurrent?: TValuesCurrentPoints[]
  valuesTimeseries?: TValuesTimeseriesPoints[]
  pointCategory?: TPointCategory
}): boolean => {
  const selectedFieldAssetState = selectedFieldAssetsStore.getState()
  const selectedProperty = selectedFieldAssetState.property

  const selectedPoint = pointCategory
    ? selectedFieldAssetState[pointCategory]
    : selectedFieldAssetState.lngLat

  const fieldAssets = fieldAssetStore.getState().properties
  const property = selectedProperty ? fieldAssets?.[selectedProperty] : null

  if (!property) return false

  const point = selectedPoint ? property.points?.[selectedPoint] : null

  if (!point) return false

  if (valuesCurrent) {
    return valuesCurrent.some((vt) => point.valuesCurrent.includes(vt))
  }

  if (valuesTimeseries) {
    return valuesTimeseries.some((vt) => point.valuesTimeseries.includes(vt))
  }

  return false
}

export const doesSelectedBlockHaveValueTypes = ({
  valuesCurrent,
  valuesTimeseries,
}: {
  valuesCurrent?: TValuesCurrentBlocks[]
  valuesTimeseries?: TValuesTimeseriesBlocks[]
}): boolean => {
  const selectedFieldAssetState = selectedFieldAssetsStore.getState()
  const selectedProperty = selectedFieldAssetState.property
  const selectedBlock = selectedFieldAssetState.block
  const fieldAssets = fieldAssetStore.getState().properties
  const property = selectedProperty ? fieldAssets?.[selectedProperty] : null

  if (!property) return false

  const block = selectedBlock ? property.blocks?.[selectedBlock] : null

  if (!block) return false

  if (valuesCurrent) {
    return valuesCurrent.some((vt) => block.valuesCurrent.includes(vt))
  }

  if (valuesTimeseries) {
    return valuesTimeseries.some((vt) => block.valuesTimeseries.includes(vt))
  }

  return false
}

export const doesSelectedRegionHaveValueTypes = ({
  valuesCurrent,
  valuesTimeseries,
}: {
  valuesCurrent?: TValuesCurrentRegions[]
  valuesTimeseries?: TValuesTimeseriesRegions[]
}): boolean => {
  const selectedRegion = selectedFieldAssetsStore.getState().region

  if (!selectedRegion) return false

  const region = fieldAssetStore.getState()?.regions?.[String(selectedRegion)]

  if (!region) return false

  if (valuesCurrent) {
    return valuesCurrent.some((vt) => region.valuesCurrent.includes(vt))
  }

  if (valuesTimeseries) {
    return valuesTimeseries.some((vt) => region.valuesTimeseries.includes(vt))
  }

  return false
}
